export default __webpack_public_path__ + "static/media/Coderpad_link.f7a1c2a4.svg";